<template>
  <form-field :name="field.name">
    <v-text-field
      v-model="field.value"
      :loading="loading"
      :prepend-icon="prependIcon"
      v-bind="field.props"
      clearable
      box
    />
  </form-field>
</template>

<script>
import formField from '@/mixins/form-field'
import { createGetParams } from '@/rest'

export default {
  mixins: [formField],
  data () {
    return {
      error: null,
      hint: '',
      input: null,
      loading: false,
    }
  },
  computed: {
    prependIcon: function () {
      return 'mdi-account-tie'
    },
    validDealer: function () {
      this.validateDealer()
      return this.error === null ? true : this.error
    },
  },
  watch: {
    'field.value': function (val) {
      this.error = 'Unverified!'
      if (val) this.field.value = val.toUpperCase()
      this.field.props.hint = this.hint
    },
  },
  mounted: function () {
    this.field.props.rules.push(val => this.validDealer)
    Object.assign(this.field.props, { validateOnBlur: true })
    if (this.hint.length === 0) {
      this.hint = this.field.props.hint === undefined || this.field.props.hint === null ? '' : this.field.props.hint
    }
  },
  methods: {
    async validateDealer () {
      if (!this.field.value) return true
      const url = 'getDealer.php'
      const params = createGetParams({
        target: this.field.value,
      })
      this.loading = true
      try {
        const response = await this.$rest.get(url, params)
        this.loading = false
        if (response.data.self === true || response.data.self === 'true') {
          this.error = 'Self-referrenced dealer!'
        } else {
          this.error = null
          this.field.props.hint = response.data.name || ''
        }
      } catch (error) {
        this.loading = false
        this.field.props.hint = ''
        if (error.response) {
          if (error.response.status === 404) {
            this.error = 'No such Dealer!'
          } else {
            this.error = error.message
          }
        } else {
          this.error = error.message
        }
      }
      this.validate()
    },
  },
}
</script>
